

export default function Help(){
    return (
        <div>
            <h1>guess RGB とは？</h1>
            <p>
                スマホやパソコンなどでつかわれる色は
                <b>赤・緑・青</b>の3つの色の組み合わせで
                出来ています。
                例えば水色であれば緑と青のみ使って（赤は使わずに）
                表示されています。
            </p>
            <p>
                表示したい色を表示するために
                赤・緑・青をそれぞれどれくらい使うか
                を表す数字をRGB値と言います。
                <b>guess RGB</b>とは
                表示された色のRGB値をあてるゲームです。
            </p>
            <p>
                RGB値は様々な指定方法がありますが、
                このゲームでは赤・緑・青をそれぞれ
                0～255の中で指定してください。
                数値が低いほど暗く、高いほど明るい色になります。
            </p>

        </div>
    );
}
